/**
 * An array of routes that are accessible to the public
 * These routes do not require authentication
 * @type {string[]}
 */

export const publicRoutes = [];

/**
 * An array of routes that are used for authentication
 * These routes will redirect users to home page
 * @type {string[]}
 */
export const authRoutes = [
  '/login',
  '/register',
  '/error',
  '/reset-password',
  '/new-password',
  '/new-verification',
  '/accept-invite',
  '/privacy',
  '/terms',
  '/contact',
  '/about',
  '/',
];

/**
 * The prefix for API authentication routes
 * Routes that start with this prefix used for API authentication purposess
 * @type {string}
 */
export const apiAuthPrefix = '/api/auth';

/**
 * The default redirect path after logging in
 * @type {string}
 */
export const DEFAULT_LOGIN_REDIRECT = '/dashboard';
